/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rn_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard Roman numerals cover 1 to 3999. There is no symbol for zero, and numbers above 3999 need overlines that aren't part of plain text.`)
};

const es_rn_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los numerales romanos estándar cubren del 1 al 3999. No hay símbolo para cero, y los números superiores a 3999 necesitan líneas superiores que no forman parte del texto plano.`)
};

const de_rn_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard-römische Zahlen decken 1 bis 3999 ab. Es gibt kein Symbol für null, und Zahlen über 3999 benötigen Überstriche, die nicht Teil von einfachem Text sind.`)
};

const nl_rn_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standaard Romeinse getallen gaan van 1 tot 3999. Er is geen symbool voor nul, en getallen boven 3999 hebben bovenstaven die geen onderdeel zijn van normale tekst.`)
};

const fr_rn_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les chiffres romains standard couvrent 1 à 3999. Il n'y a pas de symbole pour zéro, et les nombres au-dessus de 3999 ont besoin de traits de soulignement qui ne font pas partie du texte brut.`)
};

const it_rn_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I numerali romani standard coprono da 1 a 3999. Non esiste un simbolo per lo zero e i numeri superiori a 3999 hanno bisogno di sopralinee che non fanno parte del testo semplice.`)
};

const pt_br2_rn_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os numerais romanos padrão cobrem 1 a 3999. Não há símbolo para zero, e números acima de 3999 precisam de linhas acima que não fazem parte do texto simples.`)
};

const pt_rn_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os numerais romanos padrão cobrem 1 a 3999. Não existe símbolo para zero, e os números acima de 3999 necessitam de traços acima que não fazem parte do texto simples.`)
};

const ja_rn_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`標準的なローマ数字は1〜3999をカバーしています。ゼロの記号はなく、3999を超える数字は平文の一部ではないオーバーラインが必要です。`)
};

const zh_rn_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标准罗马数字的范围是 1 到 3999。没有表示零的符号，而超过 3999 的数字需要使用上划线，这在纯文本中无法表示。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rn_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rn_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rn_faq1_a", locale)
	if (locale === "en") return en_rn_faq1_a(inputs)
	if (locale === "es") return es_rn_faq1_a(inputs)
	if (locale === "de") return de_rn_faq1_a(inputs)
	if (locale === "nl") return nl_rn_faq1_a(inputs)
	if (locale === "fr") return fr_rn_faq1_a(inputs)
	if (locale === "it") return it_rn_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_rn_faq1_a(inputs)
	if (locale === "pt") return pt_rn_faq1_a(inputs)
	if (locale === "ja") return ja_rn_faq1_a(inputs)
	return zh_rn_faq1_a(inputs)
};